import {FieldTypes,ActionType} from './ReducerType';


let now = new Date();
export const initialState: FieldTypes = {

  MonthDate: new Date(now.getFullYear(), now.getMonth() - 1, 1),

    CurrentUser: {
        UserName: '',
        UserId: null 
    },

    Engagement: {
        EngagementName: '',
        EngagementId: null, 
    },

    TeamLead: {
        TeamLeadName: '',
        TeamLeadId: null
    },

    Manager: {
        ManagerName: '',
        ManagerId: null,
    },

    Managers: {
      ManagersName: '',
      ManagersId: null,
  },

    Rating: {
        RatingName: '',
        RatingId: null, 
    },

    TLRating:{
        TLRatingName:'',
        TLRatingId:null,
    },

    PMRating:{
      PMRatingName:'',
      PMRatingId:null,
    },

    RMRating:{
      RMRatingName:'',
      RMRatingId:null,
    },

    TLRemark:'',
    Remark:'',
    ProjectManagerRemark:'',
    FinalManagerRemark:'',
    Task_Ticket_Count: 0,
    Actual_Mandays: 0,
    Ontime_Count: 0,
    Issue_Count: 0,
    Issue_Mandays: 0,
    Working_Days:0,
    Not_Filled:0,
    Discrepancy:0,
    Leaves:0,
    PlannedLeave:0,
    UnPlannedLeave:0,
};



export const reducer = (state: FieldTypes, action: ActionType): FieldTypes => {
  
    switch (action.type) {
      case 'SET_MONTH_DATE':
        // const selectedDate = action.payload;    
        // const firstDateOfMonth = new Date(selectedDate.getFullYear(), selectedDate.getMonth(), 1);
        return { ...state, MonthDate: action.payload };
  
      case 'SET_CURRENT_USER':
        return { ...state, CurrentUser:{ UserName:action.payload.UserName, UserId: Number(action.payload.UserId) } };
  
      case 'SET_ENGAGEMENT':
        return { ...state, Engagement:{ EngagementName:action.payload.EngagementName, EngagementId:Number(action.payload.EngagementId) } };
  
      case 'SET_TEAM_LEAD':
        return { ...state, TeamLead: {TeamLeadName : action.payload.TeamLeadName , TeamLeadId : Number(action.payload.TeamLeadId)} };
  
      case 'SET_MANAGER':
        return { ...state, Manager:{ManagerName:action.payload.ManagerName , ManagerId: Number(action.payload.ManagerId)}  };

      case 'SET_MANAGERS':
        return { ...state, Managers:{ManagersName:action.payload.ManagersName , ManagersId: Number(action.payload.ManagersId)}  };
  
      case 'SET_RATING':
        return { ...state, Rating:{RatingName:action.payload.RatingName, RatingId: Number(action.payload.RatingId)} };

      case 'SET_TLRATING':
        return { ...state, TLRating:{TLRatingName:action.payload.TLRatingName, TLRatingId: Number(action.payload.TLRatingId)} };
  
      case 'SET_TLREMARK':
        return { ...state, TLRemark: action.payload };

      case 'SET_REMARK':
        return { ...state, Remark: action.payload };
  
      case 'SET_PMRATING':
        return { ...state, PMRating:{PMRatingName:action.payload.PMRatingName, PMRatingId: Number(action.payload.PMRatingId)} };

      case 'SET_ProjectManagerRemark':
        return {...state, ProjectManagerRemark: action.payload}

      case 'SET_RMRATING':
        return { ...state, RMRating:{RMRatingName:action.payload.RMRatingName, RMRatingId: Number(action.payload.RMRatingId)} };
  
      case 'SET_RMRemark':
        return {...state, FinalManagerRemark: action.payload}
  
      case 'SET_TASK_TICKET_COUNT':
        return { ...state, Task_Ticket_Count: action.payload };
  
      case 'SET_ACTUAL_MANDAYS':
        return { ...state, Actual_Mandays: action.payload };
  
      case 'SET_ONTIME_COUNT':
        return { ...state, Ontime_Count: action.payload };
  
      case 'SET_ISSUE_COUNT':
        return { ...state, Issue_Count: action.payload };
  
      case 'SET_ISSUE_MANDAYS':
        return { ...state, Issue_Mandays: action.payload };

      case 'SET_WORKING_DAYS':
        return{...state,Working_Days:action.payload};

      case 'SET_NOT_FILLED':
        return{...state,Not_Filled:action.payload};  

      case 'SET_DISCREPANCY':
        return{...state,Discrepancy:action.payload};

      case 'SET_LEAVES':
        return{...state,Leaves:action.payload};  

      case 'SET_PLANNED_LEAVE':
        return{...state,PlannedLeave:action.payload};  

      case 'SET_UNPLANNED_LEAVE':
        return{...state,UnPlannedLeave:action.payload};    
        
      default:
        return state;
    }
  };